import axios from 'axios';
import { APP_URL, REACT_APP_X_API_KEY, HOST_TYPE } from './apiPath';
import { getStoredUser } from '../utils/storage';
import { getLocalTimeZone } from './commonService';

const commonClient = axios.create({
    baseURL: APP_URL,
});

commonClient.interceptors.request.use(
    (config) => {
        const currentUser = getStoredUser();
        console.log('languagelanguage', localStorage.getItem('i18nextLng'))
        config.headers['language'] = localStorage.getItem('i18nextLng');
        config.headers['Accept-Language'] = localStorage.getItem('i18nextLng');
        config.headers['token'] = currentUser.token;
        config.headers['timezone'] = getLocalTimeZone();
        config.headers['x-api-key'] = REACT_APP_X_API_KEY;
        config.headers['hosttype'] = HOST_TYPE;
        config.headers['ip'] = localStorage.getItem('userIP');
        config.headers['device'] = navigator.userAgent;
        if (currentUser?.token) {
            const method = config.method.toLowerCase();
            if (method === 'post' || method === 'put' || method === 'patch') {
                config.data = { ...config.data, token: currentUser.token };
            } else if (method === 'get' || method === 'delete') {
                config.params = { ...config.params };
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default commonClient;